import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { loginThunk } from '@store/async/login';
import { logoutThunk } from '@store/async/logout';
import { State } from '..';

export type authTypes = {
  email: string | null;
  name: string;
  error: string | null;
  isLoggedIn: boolean;
  username: string | null;
  isLocalUser: boolean;
  loginLoading: boolean;
  logoutLoading: boolean;
  refreshLoading: boolean;
  refresh_token: string;
  access_token: string;
  autoLogin: boolean;
  invalidPermission: boolean;
  usernameError: string | null;
  passwordError: string | null;
  security_passphrase: string;
  role: string;
  country: string;
  phone_number: string;
  isTelnyxUser: boolean;
  loginWindowOpen: boolean;
  user_id: string;
  user_hash: string;
  telnyxFeatures: boolean;
  org_id: string;
  internalRequests: boolean;
};

const initialState: authTypes = {
  email: '',
  name: '',
  error: null,
  isLoggedIn: false,
  invalidPermission: false,
  username: null,
  loginLoading: false,
  logoutLoading: false,
  refreshLoading: false,
  autoLogin: false,
  refresh_token: '',
  access_token: '',
  isLocalUser: LOCAL === 'true',
  usernameError: null,
  passwordError: null,
  security_passphrase: '',
  role: 'default',
  country: '',
  phone_number: '',
  isTelnyxUser: false,
  loginWindowOpen: false,
  user_id: '',
  user_hash: '',
  org_id: '',
  telnyxFeatures: false,
  internalRequests: localStorage.getItem('internalRequests') === 'true',
};

export const showTelnyxFeatures = createSelector(
  [(state: State) => state.auth],
  (auth) => auth.isTelnyxUser && auth.telnyxFeatures
);

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUsername: (state, action: PayloadAction<string>) => {
      state.username = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      if (action.payload === null) {
        state.usernameError = null;
        state.passwordError = null;
      }
    },
    setLoginLoading: (state, action: PayloadAction<boolean>) => {
      state.loginLoading = action.payload;
    },
    setAutoLogin: (state, action: PayloadAction<boolean>) => {
      state.autoLogin = action.payload;
    },
    toggleTelnyxFeatures: (state) => {
      state.telnyxFeatures = !state.telnyxFeatures;

      if (state.telnyxFeatures) localStorage.removeItem('disableTelnyxFeatures');
      else localStorage.setItem('disableTelnyxFeatures', 'true');
    },
    toggleInternalRequests: (state) => {
      state.internalRequests = !state.internalRequests;

      if (state.internalRequests) localStorage.setItem('internalRequests', 'true');
      else localStorage.setItem('internalRequests', 'false');
    },
  },
  extraReducers: (builder) => {
    const loginReducer = loginThunk(builder);
    const logoutReducer = logoutThunk(builder);

    return {
      loginReducer,
      logoutReducer,
    };
  },
});

export const authActions = authSlice.actions;
export default authSlice.reducer;
